<div class="form-center-message background-white" *ngIf="messageDetails">
  <div *ngIf="messageDetails.iconName" class="form-center-message__icon"
  [ngClass]="[messageDetails.iconSize === 'large' ? 'form-center-message--large' : '']">
    <svg>
      <use [attr.xlink:href]="'/simplicity/simplicity-smaller/svgs/svgdefs.svg#i-' + messageDetails.iconName +'-sml'">\</use>
    </svg>
  </div>
  <div *ngIf="headlineConfig" class="form-center-message__headline">
    <ws10-headline-brix [headlineConfig]="headlineConfig"></ws10-headline-brix>
  </div>
  <div *ngIf="messageDetails.text" class="form-center-message__description">
    <p class="mb-0" [innerHTML]="messageDetails.text"></p>
  </div>
  <div *ngIf="buttonConfig" class="form-center-message__button">
    <ws10-button [ws10Button]="buttonConfig" (onClick)="onButtonClick()"></ws10-button>
  </div>
</div>
